import React from 'react';
import PropTypes from 'prop-types';

import { PAGE_SUB_TYPE, PAGE_TYPE } from 'constants/footPrintTracking';
import { FootPrintTracking } from 'components/Globals/FootPrintTracking';
import { withTranslation } from '../../src/i18n';
import Rentals from '../../containers/Rentals';
import { getRentals } from '../../containers/Rentals/actions';
import getInjectors from '../../store/reducerInjectors';
import reducer, { key } from '../../containers/Rentals/reducer';
import { useInjectReducer } from '../../store/injectReducer';
import { TP, PRODUCTION_VALIDITY_IDENTIFIERS, rentalsPageQueryList } from '../../constants/consts';
import route from '../../constants/routes';

const trackingData = {
  pageType: PAGE_TYPE.LISTING_PAGE,
  pageSubType: PAGE_SUB_TYPE.RENTAL,
};

const RentalsPage = ({ t, query }) => {
  useInjectReducer([{ key, reducer }]);

  const customBreadcrumbs = [
    { path: route.HOME, title: `${TP}.m_HOME` },
    { path: `${route.RENTALS}/`, title: `${TP}.m_RENTALS` },
  ];

  return (
    <FootPrintTracking data={trackingData}>
      <Rentals
        t={t}
        customBreadcrumbs={customBreadcrumbs}
        queryValues={query}
        disableQuery={false}
        pageQueryList={rentalsPageQueryList}
      />
    </FootPrintTracking>
  );
};

RentalsPage.propTypes = {
  t: PropTypes.func,
};

RentalsPage.getInitialProps = async ctx => {
  const { store, query } = ctx;
  getInjectors(store).injectReducer([{ key, reducer }]);

  store.dispatch(
    getRentals({
      ...query,
      sort: query?.sort ? query?.sort : '-year',
      published: true,
      has_active_rental: true,
      approved_by: [
        PRODUCTION_VALIDITY_IDENTIFIERS.COMPANY,
        PRODUCTION_VALIDITY_IDENTIFIERS.ADMIN,
        PRODUCTION_VALIDITY_IDENTIFIERS.FESTIVAL,
      ],
    }),
  );

  return {
    namespacesRequired: ['translation'],
    query,
  };
};

export default withTranslation('translation')(RentalsPage);
